import { getRenewalProgress } from "api/renewal";

const WORKFLOW_STEP_TO_PATH: Record<
  string,
  { section: "discussion" | "filing" | "status"; slug: string }
> = {
  RN_S1_01_PRELIMINARY_DISCUSSION: {
    section: "discussion",
    slug: "preliminary-discussion-with-the-client",
  },
  RN_S1_02_APPLICATION_DETAILS_FROM_CLIENT: {
    section: "discussion",
    slug: "application-details-from-client",
  },
  RN_S1_03_INVOICE_TO_CLIENT: {
    section: "discussion",
    slug: "invoice-to-client",
  },
  RN_S1_04_PAYMENT_FROM_CLIENT: {
    section: "discussion",
    slug: "payment-from-client-for-renewal",
  },
  RN_S2_01_STAMP_PAPER_DETAILS_TO_VENDOR: {
    section: "filing",
    slug: "stamp-paper-details-to-vendor",
  },
  RN_S2_02_STAMP_PAPER_FROM_VENDOR: {
    section: "filing",
    slug: "stamp-paper-from-vendor",
  },
  RN_S2_03_PREPARATION_OF_POA: {
    section: "filing",
    slug: "preparation-of-power-of-attorney",
  },
  RN_S2_03A_POA_FIELDS_SAVED: {
    section: "filing",
    slug: "preparation-of-power-of-attorney",
  },
  RN_S2_03B_POA_PDF_GENERATED: {
    section: "filing",
    slug: "preparation-of-power-of-attorney",
  },
  RN_S2_04_FILE_FORMS_FOR_RENEWAL: {
    section: "filing",
    slug: "file-forms",
  },
  RN_S2_05_INFORM_CLIENT_OF_FILING: {
    section: "filing",
    slug: "inform-client-of-filing",
  },
  RN_S3_01_STATUS_DOCUMENTS: {
    section: "status",
    slug: "download-status-documents",
  },
  RN_S3_02_NOTICE_TO_CLIENT: {
    section: "status",
    slug: "notice-to-client-of-renewal",
  },
  RN_S3_03_INFORM_CLIENT_OF_RENEWAL: {
    section: "status",
    slug: "inform-client-about-renewal",
  },
};

const DEFAULT_STEP = {
  section: "discussion" as const,
  slug: "preliminary-discussion-with-the-client",
};

/**
 * Resolves the in-app path for a renewal lead's most recently completed
 * workflow step so the user lands directly on it from pending items.
 *
 * Falls back to the preliminary discussion step when the lead has no completed
 * steps yet, when the step has no implemented UI route, or when progress fails.
 */
export async function getRenewalPathForLead(leadId: string): Promise<string> {
  try {
    const progress = await getRenewalProgress(leadId);
    const lastCompleted = [...progress.steps]
      .reverse()
      .find((s) => s.isCompleted)?.slug;
    const stepKey =
      lastCompleted ?? progress.maxStepReached ?? progress.currentStep ?? null;
    const pathSpec = stepKey ? WORKFLOW_STEP_TO_PATH[stepKey] : null;
    const { section, slug } = pathSpec ?? DEFAULT_STEP;
    return `/dashboard/renewal/new/${section}/${slug}/${leadId}`;
  } catch {
    return `/dashboard/renewal/new/discussion/preliminary-discussion-with-the-client/${leadId}`;
  }
}
